//data status etat
export const dataState = [
    {
        "id": "accepted",
        "name": "Acceptée",
        "priority": 6,
        "default": false,
        "class": 'badge bg-success'
    },
    {
        "id": "cancelled",
        "name": "Annulé",
        "priority": 9,
        "default": false,
        "class": 'badge-soft-secondary'
    },
    {
        "id": "refused",
        "name": "Refusée",
        "priority": 7,
        "default": false,
        "class": 'badge-soft-refuse'
    },
    {
        "id": "deleted",
        "name": "Supprimé",
        "priority": 8,
        "default": false,
        "class": 'badge-soft-refuse'
    },
    {
        "id": "draft",
        "name": "Brouillon",
        "priority": 1,
        "default": false,
        "class": 'badge-soft-brouillon'
    },
    {
        "id": "expired",
        "name": "Expiré",
        "priority": 5,
        "default": false,
        "class": 'badge-soft-refuse'
    },
    {
        "id": "not_approved",
        "name": "En attente",
        "priority": 13,
        "default": false,
        "class": 'badge-soft-attente'
    },
    {
        "id": "open",
        "name": "Ouvert",
        "priority": 3,
        "default": false,
        "class": 'badge-soft-ouvert'
    },
    {
        "id": "reviewed",
        "name": "Revu",
        "priority": 12,
        "default": false,
        "class": 'badge-soft-success'
    },
    {
        "id": "sent",
        "name": "Envoyée",
        "priority": 4,
        "default": false,
        "class": 'badge-soft-info'
    }
]

//data status avencement
export const advancementData = [
    {
        "id": "6f66da25",
        "name": "Compromis signé",
        "class": 'badge bg-info'
    },
    {
        "id": "autres",
        "name": "Autres",
        "class": 'badge-soft-secondary'
    },
    {
        "id": "f70500fe",
        "name": "Proposition acceptée par vendeur",
        "class": 'badge bg-success'
    },
    {
        "id": "recherche_dun_bien",
        "name": "Recherche d'un bien",
        "class": 'badge-soft-info'
    }
]
//data status
export const statusFolder = [
    {
        "id": "approuved",
        "name": "Approuvé par le courtier",
        "class": 'badge bg-success'
    },
    {
        "id": "assurance_acceptee",
        "name": "Rédaction de l'offre de prêt",
        "class": 'badge bg-info'
    },

    {
        "id": "deleted",
        "name": "Supprimé de la source",
        "class": 'badge bg-danger'
    },
    {
        "id": "expected_signature",
        "name": "Attente signature mandat ...",
        "class": 'badge-soft-attente'
    },
    {
        "id": "fonds_debloques",
        "name": "Félicitation, facturation du mandat",
        "class": 'badge-soft-success'
    },
    {
        "id": "fonds_non_debloques",
        "name": "Fonds non débloqués",
        "class": 'badge-soft-refuse'
    },
    {
        "id": "signed",
        "name": "Mandat signé",
        "class": 'badge-soft-pry'
    },
    {
        "id": "open",
        "name": "Nouveau",
        "class": 'badge-soft-ouvert'
    },
    {
        "id": "processed",
        "name": "En cours de traitement",
        "class": 'badge-soft-pry'
    },
    {
        "id": "more_info_requested",
        "name": "Complément d'informations demandé",
        "class": 'badge-soft-attente'
    }
]